export default __webpack_public_path__ + "static/media/info-icon.aca45086.svg";